import { DependencyStore, Override } from '@bryntum/gantt';
import { GanttType } from 'components/organisms/projects/project-plan/timeline/helpers';

/**
 * Overrides default validation method for dependency to
 * 1. prevent dropping dependency lines on phase.
 * 2. allow only end to start dependencies using dependencyType param
 * Ref: https://www.bryntum.com/docs/gantt/api/Scheduler/model/DependencyBaseModel#property-Type-static
 */
class DependencyStoreOverride {
  private _overridden: any;

  static get target() {
    return {
      class: DependencyStore,
    };
  }

  isValidDependency(source, target, dependencyType) {
    const validityPromise = this._overridden.isValidDependency.call(
      this,
      source,
      target,
    );

    return validityPromise.then(
      (isValid) =>
        isValid &&
        ((target.type === GanttType.ProjectPhaseBar &&
          source.type === GanttType.ProjectPhaseBar) ||
          (target.type !== GanttType.ProjectPhaseBar &&
            source.type !== GanttType.ProjectPhaseBar)) &&
        /**
         * check if dependency is of `EndToStart` type
         */
        dependencyType === 2,
    );
  }
}
Override.apply(DependencyStoreOverride);
